export default __webpack_public_path__ + "static/media/managed-it-services.62847f82.png";